<rid-reading-matrix-stopwatch
  class="h-dvh"
  [matrices]="[
    [
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
      ['guur', 'ijs', 'jaar', 'jas', 'lees', 'jas'],
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
    ],
    [
      ['aai', 'aan', 'gaaf', 'mos', 'gum', 'goor'],
      ['aai', 'aan', 'gaaf', 'mos', 'goor'],
    ],
  ]"
  [previousDuration]="previousDuration()"
  [previousAccuracy]="previousAccuracy()"
  (finished)="$router.navigate(['/mechanics/reading-matrix'])"
/>
